import React, {
  useCallback, useContext, useState
} from 'react';
import { useNavigate } from 'react-router-dom';

import { ButtonBar, ScreenHeader } from '../../components';
import { useScrollToTop } from '../../hooks';

import { NewPOAContext } from './new-poa-composer';

export function NewPOAPersonalBenefit() {
  const { powerOfAttorney, setPowerOfAttorney } = useContext(NewPOAContext);
  const navigate = useNavigate();
  const [ allowPersonalBenefit, setAllowPersonalBenefit ] = useState(powerOfAttorney.allow_personal_benefit || false);
  
  useScrollToTop();

  const handleBack = useCallback(() => {
    navigate('../reports-complete');
  }, [ navigate ]);

  const handleNext = useCallback(() => {
    setPowerOfAttorney(prev => ({ 
      ...prev, 
      allow_personal_benefit: allowPersonalBenefit
    }));
    navigate('../keeping-assets-separate');
  }, [ allowPersonalBenefit, setPowerOfAttorney, navigate ]);
  
  return (
    <div className="new-poa-personal-benefit screen-container screen">
      <ScreenHeader
        title="Granting Personal Benefit"
        description="Decide whether your agent may benefit personally from their actions"
        handleBack={handleBack}
      />
      
      <div className="content-section">
        <h3>What Does Personal Benefit Mean?</h3>
        <p>
          Personal benefit refers to whether your agent may take actions that 
          benefit themselves personally while acting on your behalf. This could include:
        </p>
        <ul className="benefit-examples">
          <li>Making investments that also benefit the agent</li>
          <li>Using your property in ways that benefit the agent</li>
          <li>Making business decisions that help the agent's interests</li>
          <li>Taking actions that create indirect benefits for the agent</li>
        </ul>

        <h3>Important Considerations</h3>
        <ul className="benefit-considerations">
          <li>Your agent must always act in your best interests first</li>
          <li>Any personal benefit should be incidental, not the primary purpose</li>
          <li>Conflicts of interest should be avoided or disclosed</li>
          <li>Your agent has a duty of loyalty to you</li>
        </ul>

        <h3>Do You Want to Allow Personal Benefit?</h3>
        <div className="benefit-authorization">
          <div className="benefit-option">
            <label className="benefit-label">
              <input
                type="radio"
                name="personal-benefit"
                checked={!allowPersonalBenefit}
                onChange={() => setAllowPersonalBenefit(false)}
              />
              <div className="benefit-content">
                <h4>No</h4>
                <p>My agent may not benefit personally from their actions</p>
              </div>
            </label>
          </div>

          <div className="benefit-option">
            <label className="benefit-label">
              <input
                type="radio"
                name="personal-benefit"
                checked={allowPersonalBenefit}
                onChange={() => setAllowPersonalBenefit(true)}
              />
              <div className="benefit-content">
                <h4>Yes</h4>
                <p>My agent may benefit personally if it serves my interests</p>
              </div>
            </label>
          </div>
        </div>

        <div className="important-note">
          <h4>Important:</h4>
          <p>
            Even if you allow personal benefit, your agent must always act primarily 
            in your best interests. Any personal benefit should be secondary and should 
            not compromise their duty to you.
          </p>
        </div>
      </div>

      <ButtonBar 
        handlePrimary={handleNext}
        primaryText="Continue"
      />
    </div>
  );
}
